import { FavoriteBorder } from "@mui/icons-material";
import { Badge } from "@mui/material";
import React from "react";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";
import { myWishListFn } from "../../Services/Products/Wishlist";

const WishlistButton = () => {
  const navigate = useNavigate();
  const { data: myWishList } = useQuery(
    ["myWishList"],
    () => localStorage.getItem("bhaarattoken") && myWishListFn(),
    {
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  );
  return (
    <Badge
      color="primary"
      badgeContent={myWishList?.data?.data?.wishlist_product_list?.length || 0}
    >
      <FavoriteBorder
        onClick={() =>
          localStorage.getItem("bhaarattoken")
            ? navigate("/wishlist")
            : navigate("/login")
        }
      />
    </Badge>
  );
};

export default WishlistButton;
